import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Notification } from './notification.model';
import { RailcarCPdNotificationData } from './railcar-cpd-data.model';
import { Observable } from 'rxjs';

@ Injectable({providedIn: 'root'})
export class Rail360NotificationService {
	private serviceTypesUrl: any;
	private url: string;

	constructor(private httpClient: HttpClient) {
		this.url = 'api/rail360notification';
	}

	public getRailcarCPdNotificationData(notification: Notification): Observable<RailcarCPdNotificationData> {
		return this.httpClient.post<RailcarCPdNotificationData>(this.url + '/getDataForRailcarCPd', notification);
	}
}
